"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var SettingsTab = /** @class */ (function (_super) {
    __extends(SettingsTab, _super);
    function SettingsTab(props) {
        return _super.call(this, props) || this;
    }
    SettingsTab.prototype.render = function () {
        var _this = this;
        return (React.createElement(reactstrap_1.NavItem, null,
            React.createElement(reactstrap_1.NavLink, { className: this.props.activeTab == this.props.tabId ? "active" : "", onClick: function () { _this.props.onClick(_this.props.tabId); } }, this.props.tabTitle)));
    };
    return SettingsTab;
}(React.Component));
exports.SettingsTab = SettingsTab;
//# sourceMappingURL=SettingsTab.js.map